export const removeEmojis = text => {
    if (!text) return '';
    return text.replace(
        /([\u231A-\u231B]|[\u23E9-\u23EC]|[\u23F0\u23F3]|[\u25FD-\u25FE]|[\u2614-\u2615]|[\u2648-\u2653]|[\u267F]|[\u2693]|[\u26A1]|[\u26AA-\u26AB]|[\u26BD-\u26BE]|[\u26C4-\u26C5]|[\u26CE]|[\u26D4]|[\u26EA]|[\u26F2-\u26F3]|[\u26F5]|[\u26FA]|[\u26FD]|[\u2702-\u2705]|[\u2708-\u270D]|[\u2728]|[\u274C-\u274E]|[\u2753-\u2755]|[\u2757]|[\u2795-\u2797]|[\u27B0]|[\u27BF]|[\u2B50]|[\u2B55]|[\u2934-\u2935]|[\u2B05-\u2B07]|[\u3030]|[\u303D]|[\u3297]|[\u3299]|[\uD83C][\uDC00-\uDFFF]|[\uD83D][\uDC00-\uDFFF]|[\uD83E][\uDD00-\uDDFF])|[\u200D\uFE0F]/g,
        ''
    );
};

export const escapeEmojis = text => {
    if (!text) return '';
    return text.replace(
        /([\u231A-\u231B]|[\u23E9-\u23EC]|[\u23F0\u23F3]|[\u25FD-\u25FE]|[\u2614-\u2615]|[\u2648-\u2653]|[\u267F]|[\u2693]|[\u26A1]|[\u26AA-\u26AB]|[\u26BD-\u26BE]|[\u26C4-\u26C5]|[\u26CE]|[\u26D4]|[\u26EA]|[\u26F2-\u26F3]|[\u26F5]|[\u26FA]|[\u26FD]|[\u2702-\u2705]|[\u2708-\u270D]|[\u2728]|[\u274C-\u274E]|[\u2753-\u2755]|[\u2757]|[\u2795-\u2797]|[\u27B0]|[\u27BF]|[\u2B50]|[\u2B55]|[\u2934-\u2935]|[\u2B05-\u2B07]|[\u3030]|[\u303D]|[\u3297]|[\u3299]|[\uD83C][\uDC00-\uDFFF]|[\uD83D][\uDC00-\uDFFF]|[\uD83E][\uDD00-\uDDFF])|[\u200D\uFE0F]/g,
        match => `\\u{${match.codePointAt(0).toString(16)}}`
    );
};

export const unescapeEmojis = text => {
    if (!text) return '';
    return text.replace(/\\u\{([0-9a-fA-F]+)\}/g, (match, hex) => {
        const codePoint = parseInt(hex, 16);
        return String.fromCodePoint(codePoint);
    });
};
